module.exports = __webpack_public_path__ + "media/images/bg_top_mv_sp-3af7006bf70995a147fe03fc274c7fcc.jpg";